import { render, staticRenderFns } from "./GameMiscShop.vue?vue&type=template&id=efa50a8e&scoped=true&"
import script from "./GameMiscShop.vue?vue&type=script&lang=js&"
export * from "./GameMiscShop.vue?vue&type=script&lang=js&"
import style0 from "./GameMiscShop.vue?vue&type=style&index=0&id=efa50a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa50a8e",
  null
  
)

export default component.exports